export const SET_ITEMS_FILTER = "SET_ITEMS_FILTER";
export const RESET_ITEMS_FILTER = "RESET_ITEMS_FILTER";
export const SET_SEARCH = "SET_SEARCH";
export const RESET_SEARCH = "RESET_SEARCH";
